import { Api } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";

export class ImgLic {
    private static instance: ImgLic;
    private static RenlgxLicensed: boolean = false;

    private constructor()
    {
    }

    static async renlgxLicensed(): Promise<boolean> {
        if( !this.instance )
        {
            this.instance = new ImgLic();
            this.RenlgxLicensed = await this.instance.isAccessAllowed("renlgx");
        }
        return( this.RenlgxLicensed );
    }

    async isAccessAllowed(module: string): Promise<boolean> {
        let st: boolean = false;
        await Api.post("imaging-services/imglicserver", { action: "check", module: module }).then(response => {
           if (response)
            {
                st = response.data[0].licensed >= 1 && response.data[0].licensed <= 3 ? true : false;
           }
           else
            {
                CommonDialogs.showMessage("Failed to check module...", "Document Power");
            }
        });
        return st;
    }
}
